import { useTranslations } from "use-intl";
import { useFormatters } from "@financialharmony/ui";
import type { PaymentVerification } from "@/types/payments";
import type { PaymentVerificationDisplay } from "@/utils/paymentUtils";

/** `getPaymentVerificationDisplay`, worded and dated in the language the app shows. */
export function usePaymentVerificationDisplay() {
  const t = useTranslations("consultantPayables.verification");
  const { formatDate } = useFormatters();
  return (paymentVerification: PaymentVerification | null | undefined): PaymentVerificationDisplay | null => {
    if (!paymentVerification) return null;

    if (paymentVerification.status === "matched") {
      return { label: t("bankVerified"), description: t("bankVerifiedDescription") };
    }

    const who = paymentVerification.acknowledgedBy || t("yourAccountant");
    const when = paymentVerification.acknowledgedAt ? formatDate(paymentVerification.acknowledgedAt, "numeric") : undefined;
    return {
      label: t("unverified"),
      description: when ? t("confirmedByOn", { who, when }) : t("confirmedBy", { who }),
    };
  };
}
